import {TOption} from './TOption'

export const CONTRACT_STATUS: TOption[] = [
  {value: '1', label: 'Menunggu Persetujuan Level'},
  {value: '2', label: 'Revisi'},
  {value: '3', label: 'Proses PersetujuanLevel'},
  {value: '4', label: 'Kontrak Terbit'},
  {value: '6', label: 'Siap Diambil'},
  {value: '7', label: 'Proses Realisasi Customer'},
  {value: '8', label: 'Proses Pengambilan'},
  {value: '9', label: 'Selesai'},
  {value: '10', label: 'Diamandemen'},
  {value: '11', label: 'Menunggu Kontrak'},
  {value: '13', label: 'SAP Error'},
  {value: '99', label: 'Ditolak'},
]
